import { optimalBluePricingApi } from 'app/services/api';

import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const PRICE_CONCESSION_ACTION_TYPE = createNamedActions('pricing/priceConcession', {
  GET_PRICE_CONCESSION_CONFIGURATION: 'GET_PRICE_CONCESSION_CONFIGURATION',
  SET_PRICE_CONCESSION_CONFIGURATION: 'SET_PRICE_CONCESSION_CONFIGURATION',
  RESET_PRICE_CONCESSION_CONFIGURATION: 'RESET_PRICE_CONCESSION_CONFIGURATION',
});

export const getPriceConcessionConfigurationAction = catchAsyncActionError(
  ({ applicationId, ...params }) =>
    async dispatch => {
      const { data } = await optimalBluePricingApi.getPriceConcessionConfiguration(
        applicationId,
        params,
      );

      return dispatch({
        type: PRICE_CONCESSION_ACTION_TYPE.SET_PRICE_CONCESSION_CONFIGURATION,
        payload: data,
      });
    },
);
